import { ERulerActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const disableRuler = actionGenerator<ERulerActionType.RulerDisabled>(ERulerActionType.RulerDisabled);
